<h2 class="modal-title" mat-dialog-title>
    <span
        >{{ 'CONFIGURATOR_QUOTATION|Przygotowanie wydruku' | translate }} @if
        (configurationShortcode) {
        <span>
            {{ 'CONFIGURATOR_QUOTATION|dla konfiguracji' | translate }}
            <b>{{ configurationShortcode }}</b></span
        >
        }</span
    >
</h2>
<mat-dialog-content>
    <mat-checkbox [(ngModel)]="showDimensions" class="enable-client-info-checkbox">{{
        'CONFIGURATOR_QUOTATION|Prezentuj wymiary rysunku' | translate
    }}</mat-checkbox
    ><br />
    @if (!hiddenPrice) {
    <mat-checkbox [(ngModel)]="clientInfoFormEnabled" class="enable-client-info-checkbox">{{
        'CONFIGURATOR_QUOTATION|Oferta z danymi klienta i rabatem' | translate
    }}</mat-checkbox>
    } @if (hiddenPrice) {
    <mat-checkbox [(ngModel)]="clientInfoFormEnabled" class="enable-client-info-checkbox">{{
        'CONFIGURATOR_QUOTATION|Oferta z danymi klienta' | translate
    }}</mat-checkbox>
    }
    <div [class.client-info-form--disabled]="!clientInfoFormEnabled" class="client-info-form">
        <mat-card appearance="outlined" class="mat-elevation-z4 offer-info-section">
            <mat-card-title>{{ 'CONFIGURATOR_QUOTATION|Dane oferty' | translate }}</mat-card-title>
            <mat-card-content class="offer-info-section__fields">
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'CONFIGURATOR_QUOTATION|Czas ważności' | translate }}</mat-label>
                    <input
                        type="number"
                        [(ngModel)]="offerDurationInDays"
                        [disabled]="!clientInfoFormEnabled"
                        matInput
                        iccNumberInput
                        [iccNumberInputInteger]="true"
                    />
                    <mat-hint>{{
                        'CONFIGURATOR_QUOTATION|Czas ważności oferty w dniach' | translate
                    }}</mat-hint>
                </mat-form-field>
                <mat-form-field appearance="outline" class="comment-field">
                    <mat-label>{{ 'INTERFACE|Uwagi' | translate }}</mat-label>
                    <textarea
                        name="comment"
                        [(ngModel)]="comment"
                        [disabled]="!clientInfoFormEnabled"
                        class="comment-field__comment-textarea"
                        matInput
                        #commentInput
                        rows="5"
                    ></textarea>
                    <mat-hint align="end">{{ commentInput.value.length }} / 300</mat-hint>
                </mat-form-field>
                @if (config().IccConfig.Configurators.configurationQuantityWithButtonsAndCustomName)
                {
                <mat-form-field appearance="outline" class="custom-construction-name">
                    <mat-label>{{ 'INTERFACE|Nazwa' | translate }}</mat-label>
                    <textarea
                        class="custom-construction-name__textarea"
                        [(ngModel)]="customConstructionName"
                        [disabled]="!clientInfoFormEnabled"
                        matInput
                        #customConstructionNameInput
                        rows="2"
                    >
                    </textarea>
                    <mat-hint align="end"
                        >{{ customConstructionNameInput.value.length }} / 300</mat-hint
                    >
                </mat-form-field>
                }
            </mat-card-content>
        </mat-card>
        <mat-card appearance="outlined" class="mat-elevation-z4 client-info-section">
            <mat-card-title>{{ 'CONFIGURATOR_QUOTATION|Dane klienta' | translate }}</mat-card-title>
            <mat-card-content class="client-info-section__fields">
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'PERSON|Imię' | translate }}</mat-label>
                    <input [(ngModel)]="name" [disabled]="!clientInfoFormEnabled" matInput />
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'PERSON|Nazwisko / Nazwa' | translate }}</mat-label>
                    <input [(ngModel)]="fullName" [disabled]="!clientInfoFormEnabled" matInput />
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'CONTACT|Numer telefonu' | translate }}</mat-label>
                    <input [(ngModel)]="phoneNumber" [disabled]="!clientInfoFormEnabled" matInput />
                </mat-form-field>
            </mat-card-content>
        </mat-card>
        <mat-card appearance="outlined" class="mat-elevation-z4 address-info-section">
            <mat-card-title>{{
                'CONFIGURATOR_QUOTATION|Adres inwestycji' | translate
            }}</mat-card-title>
            <mat-card-content class="address-info-section__fields">
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'CONTACT|Adres' | translate }}</mat-label>
                    <input [(ngModel)]="address" [disabled]="!clientInfoFormEnabled" matInput />
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'CONTACT|Miejscowość' | translate }}</mat-label>
                    <input [(ngModel)]="city" [disabled]="!clientInfoFormEnabled" matInput />
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'CONTACT|Kod pocztowy' | translate }}</mat-label>
                    <input [(ngModel)]="postCode" [disabled]="!clientInfoFormEnabled" matInput />
                </mat-form-field>
            </mat-card-content>
        </mat-card>
        <mat-card appearance="outlined" class="mat-elevation-z4 price-info-section">
            <mat-card-title>{{ 'CONFIGURATOR_QUOTATION|Wycena' | translate }}</mat-card-title>
            <mat-card-content>
                <table class="mat-table price-info-section__table">
                    <tr class="mat-header-row">
                        <th class="mat-header-cell"></th>
                        @if (!hiddenPrice) {
                        <th class="mat-header-cell">
                            {{ 'CONFIGURATOR_QUOTATION|Cena netto' | translate }}
                        </th>
                        }
                        <th class="mat-header-cell">
                            {{ 'CONFIGURATOR_QUOTATION|Ilość' | translate }}
                        </th>
                        @if (!hiddenPrice) {
                        <th class="mat-header-cell">
                            {{ 'CONFIGURATOR_QUOTATION|Wartość netto' | translate }}
                        </th>
                        }
                    </tr>
                    <tr class="mat-row">
                        <td class="mat-cell">{{ positionName }}</td>
                        @if (!hiddenPrice) {
                        <td class="mat-cell">
                            <mat-form-field appearance="outline" class="no-spin-buttons">
                                @if (currencyIsPrefix) {
                                <span matTextPrefix>{{ currencySymbol }}&nbsp;</span>
                                }
                                <input
                                    [(ngModel)]="nettoPrice"
                                    type="number"
                                    [disabled]="!clientInfoFormEnabled"
                                    matInput
                                    (blur)="changedInputData('default')"
                                    inputmode="decimal"
                                />
                                @if (!currencyIsPrefix) {
                                <span matTextSuffix>&nbsp;{{ currencySymbol }}</span>
                                }
                            </mat-form-field>
                        </td>
                        }
                        <td class="mat-cell">
                            <mat-form-field appearance="outline" class="no-spin-buttons">
                                <input
                                    [(ngModel)]="quantity"
                                    min="0"
                                    type="number"
                                    [disabled]="!clientInfoFormEnabled"
                                    matInput
                                    inputmode="decimal"
                                    (blur)="changedInputData('default')"
                                />
                            </mat-form-field>
                        </td>
                        @if (!hiddenPrice) {
                        <td class="mat-cell align-text-right">{{ getNettoPrice() | currency : currency : null : false : false }}</td>
                        }
                    </tr>
                    @if (!hiddenPrice) {
                    <tr class="mat-row">
                        <td class="mat-cell">
                            {{ 'CONFIGURATOR_QUOTATION|Rabat' | translate }}
                        </td>
                        <td class="mat-cell"></td>
                        <td class="mat-cell"></td>
                        <td class="mat-cell">
                            <div class="price-info-section__discount-fields">
                                <mat-form-field appearance="outline" class="no-spin-buttons">
                                    <input
                                        [(ngModel)]="discountPercent"
                                        type="number"
                                        min="0"
                                        max="100"
                                        [disabled]="!clientInfoFormEnabled"
                                        matInput
                                        (input)="changedInputData('discountPercent')"
                                        inputmode="decimal"
                                    />
                                    <span matTextSuffix>%</span>
                                </mat-form-field>

                                <mat-form-field appearance="outline" class="no-spin-buttons">
                                    @if (currencyIsPrefix) {
                                    <span matTextPrefix>{{ currencySymbol }}&nbsp;</span>
                                    }
                                    <input
                                        [(ngModel)]="discountCash"
                                        type="number"
                                        [disabled]="!clientInfoFormEnabled"
                                        matInput
                                        (input)="changedInputData('discountCash')"
                                        inputmode="decimal"
                                    />
                                    @if (!currencyIsPrefix) {
                                    <span matTextSuffix>&nbsp;{{ currencySymbol }}</span>
                                    }
                                </mat-form-field>
                            </div>
                        </td>
                    </tr>
                    } @if (!hiddenPrice) {
                    <tr class="mat-row">
                        <td class="mat-cell">
                            {{ 'CONFIGURATOR_QUOTATION|Usługi dodatkowe' | translate }}
                        </td>
                        <td class="mat-cell"></td>
                        <td class="mat-cell"></td>
                        <td class="mat-cell align-text-right">
                            <mat-form-field appearance="outline" class="no-spin-buttons">
                                @if (currencyIsPrefix) {
                                <span matTextPrefix>{{ currencySymbol }}&nbsp;</span>
                                }
                                <input
                                    [(ngModel)]="additionalServicesPrice"
                                    type="number"
                                    [disabled]="!clientInfoFormEnabled"
                                    matInput
                                    (blur)="changedInputData('default')"
                                    inputmode="decimal"
                                />
                                @if (!currencyIsPrefix) {
                                <span matTextSuffix>&nbsp;{{ currencySymbol }}</span>
                                }
                            </mat-form-field>
                        </td>
                    </tr>
                    } @if (!hiddenPrice) {
                    <tr class="mat-row">
                        <td class="mat-cell">
                            {{ 'CONFIGURATOR_QUOTATION|Razem netto' | translate }}
                        </td>
                        <td class="mat-cell"></td>
                        <td class="mat-cell"></td>
                        <td class="mat-cell align-text-right">
                            <mat-form-field appearance="outline" class="no-spin-buttons">
                                @if (currencyIsPrefix) {
                                <span matTextPrefix>{{ currencySymbol }}&nbsp;</span>
                                }
                                <input
                                    [ngModel]="fullNettoPrice"
                                    (ngModelChange)="fullNettoPrice = $event"
                                    class="no-spin-buttons"
                                    type="number"
                                    [disabled]="!clientInfoFormEnabled"
                                    matInput
                                    (input)="changedInputData('fullNettoPrice')"
                                    inputmode="decimal"
                                />
                                @if (!currencyIsPrefix) {
                                <span matTextSuffix>&nbsp;{{ currencySymbol }}</span>
                                }
                            </mat-form-field>
                        </td>
                    </tr>
                    } @if (!hiddenPrice) {
                    <tr class="mat-row">
                        <td class="mat-cell">{{ 'CONFIGURATOR_QUOTATION|VAT' | translate }}</td>
                        <td class="mat-cell">
                            <mat-form-field appearance="outline">
                                <mat-select
                                    [(ngModel)]="selectedVat"
                                    [disabled]="!clientInfoFormEnabled"
                                    (selectionChange)="changedInputData('vat')"
                                >
                                    @for (vat of taxRates; track vat) {
                                    <mat-option [value]="vat.value">
                                        {{ vat.name }}
                                    </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </td>
                        <td class="mat-cell"></td>
                        <td class="mat-cell align-text-right">
                            {{ vatPrice | currency : currency : null : false : false }}
                        </td>
                    </tr>
                    } @if (!hiddenPrice) {
                    <tr class="mat-row">
                        <td class="mat-cell">{{ 'CONFIGURATOR_QUOTATION|Razem' | translate }}</td>
                        <td class="mat-cell"></td>
                        <td class="mat-cell"></td>
                        <td class="mat-cell align-text-right">
                            <mat-form-field appearance="outline" class="no-spin-buttons">
                                @if (currencyIsPrefix) {
                                <span matTextPrefix>{{ currencySymbol }}&nbsp;</span>
                                }
                                <input
                                    class="no-spin-buttons"
                                    type="number"
                                    matInput
                                    [ngModel]="fullPrice"
                                    (ngModelChange)="fullPrice = $event"
                                    [disabled]="!clientInfoFormEnabled"
                                    (input)="changedInputData('fullPrice')"
                                    inputmode="decimal"
                                />
                                @if (!currencyIsPrefix) {
                                <span matTextSuffix>&nbsp;{{ currencySymbol }}</span>
                                }
                            </mat-form-field>
                        </td>
                    </tr>
                    } @if (!hiddenPrice) {
                    <tr class="mat-row">
                        <td class="mat-cell" colspan="4">
                            <button mat-raised-button (click)="resetToDefaults()">
                                {{ 'CONFIGURATOR_QUOTATION|Resetuj cenę' | translate }}
                            </button>
                        </td>
                    </tr>
                    }
                </table>
            </mat-card-content>
        </mat-card>
        <mat-card appearance="outlined" class="mat-elevation-z4 details-info">
            <mat-card-title>{{ 'INTERFACE|Szczegóły' | translate }}</mat-card-title>
            <mat-card-content>
                <p>
                    <mat-checkbox
                        (change)="toggleCheckbox('download-pdf', $event)"
                        [checked]="isCheckboxChecked('download-pdf')"
                        >{{ 'CONFIGURATOR_QUOTATION|Pobierz PDF' | translate }}</mat-checkbox
                    >
                </p>
                <p>
                    <mat-checkbox (change)="toggleCheckbox('pdf-on-email', $event)">{{
                        'CONFIGURATOR_QUOTATION|Wyślij PDF na email' | translate
                    }}</mat-checkbox>
                </p>
                @if (showContactRequest) {
                <p>
                    <mat-checkbox (change)="toggleCheckbox('contact-request', $event)">{{
                        'CONFIGURATOR_QUOTATION|Proszę o kontakt' | translate
                    }}</mat-checkbox>
                </p>
                } @if (clause && isContactRequestCheckboxChecked) {
                <p class="details-info__clause" [innerHTML]="clause"></p>
                }
                <p class="details-info__validator">
                    <mat-form-field
                        ><input matInput [(ngModel)]="validatorForAutomatedAttacks"
                    /></mat-form-field>
                </p>
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'CONTACT|Adres' | translate }}</mat-label>
                    <input
                        class="details-info__input-email"
                        [(ngModel)]="email"
                        [disabled]="isFieldDisabled('email')"
                        matInput
                    />
                </mat-form-field>
                @if (isContactRequestCheckboxChecked) {
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'CONTACT|Nr telefonu' | translate }}</mat-label>
                    <input
                        class="details-info__input-phone"
                        [(ngModel)]="phone"
                        [disabled]="isFieldDisabled('phone')"
                        matInput
                    />
                </mat-form-field>
                }
                <p>
                    @if (marketUrlAvailable()) {
                    <mat-checkbox [(ngModel)]="findBusinessPartner">{{
                        getUrlButtonText()
                    }}</mat-checkbox>
                    }
                </p>
            </mat-card-content>
        </mat-card>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close class="mat-elevation-z4">
        {{ 'INTERFACE|Anuluj' | translate }}
    </button>
    <button
        mat-raised-button
        color="primary"
        class="mat-elevation-z4 print-button"
        (click)="closeWithData()"
        [disabled]="isFieldDisabled('print-button')"
    >
        {{ getButtonName() }}
    </button>
</mat-dialog-actions>
